import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { NavigationEnd, Params, Router } from "@angular/router";

import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent
  extends FeaturesBaseComponent
  implements AfterViewInit, OnDestroy {
  @ViewChild("reportsButtonTxt", { static: false })
  reportsButtonTxt: ElementRef;
  @ViewChild("reportsButton", { static: false }) reportsButton: ElementRef;
  @ViewChild("reportMenuBar", { static: false }) reportMenuBar: ElementRef;

  display: boolean = false;
  userRole: string = '';

  constructor(private router: Router) {
    super();
    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;

  }

  ngAfterViewInit(): void {
    this.router.events.subscribe((val) => {

      if (val["url"] == "/features/reports") {
        this.reportsButtonTxt.nativeElement.innerHTML = "Billing";
      }
      // see also
      //
      //
    });
    if (this.isBilling()) {
      this.onSelectPaymentReport()
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
  resetDropDownMenuReports() {
    this.reportsButtonTxt.nativeElement.innerHTML = "Billing";
    let el: any = this.reportsButton;
    el._elementRef.nativeElement.classList.remove("router-link-active");
  }
  onSelectPaymentReport() {
    this.reportsButtonTxt.nativeElement.innerHTML = "Payment Report";
    let el: any = this.reportsButton;
    el._elementRef.nativeElement.classList.add("router-link-active");
  }
  onSelectInvoiceReport() {
    this.reportsButtonTxt.nativeElement.innerHTML = "Invoice Report";
    let el: any = this.reportsButton;
    el._elementRef.nativeElement.classList.add("router-link-active");
  }

  onClickLeft() {
    this.reportMenuBar.nativeElement.scrollLeft -= 40;
  }

  onClickRight() {
    this.reportMenuBar.nativeElement.scrollLeft += 40;
  }
  rolecheck() { //alert("hello")
    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    let current_userRole: string = decoded_token.role;

    if (current_userRole == "Sales Rep" || current_userRole == "Customer Service") {
      this.display = true
      return; //"{'diasplay':'none'}";
    } else {
      this.display = false
      return;
    }
  }

  isBilling(): boolean {
    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    let current_userRole: string = decoded_token.role;

    if (current_userRole == "Billing Dept") {
      return true;
    }
    return false
  }
}
